import { request } from '@/shared/api/request'

export const cleanPersonProfile = () =>
	request({ url: '/user/save/cleanCurrentPersonDetails', method: 'POST', data: {} })
